import React, { useEffect } from 'react';

import styled from 'styled-components';

import { ESpacing } from '@aquariuxfintech/aqx-trader-react-ui/foundation';

import {
  EResetPasswordExperienceContent,
  resetPasswordExperienceViewController,
  useResetPasswordExperience
} from '@aqx-core/common/services/reset-password-experience';

import ResetPasswordComplete from './content/completed';
import ResetPasswordForm from './content/form';

const ResetPasswordScreen: FCC = () => {
  const { content } = useResetPasswordExperience();

  useEffect(() => {
    return () => resetPasswordExperienceViewController.reset();
  }, []);
  return (
    <StyledContainer>
      {content === EResetPasswordExperienceContent.FORM ? <ResetPasswordForm /> : <ResetPasswordComplete />}
    </StyledContainer>
  );
};

export default ResetPasswordScreen;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  gap: ${ESpacing.M}px;
`;
